import { AssociationsService } from 'app/services/associations/associations.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationCompany } from '../../../models/applicationCompany.model';
import { Company } from '../../../models/company.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { CompaniesService } from '../../../services/company/companies.service';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';

@Component({
  selector: 'app-campanies',
  providers: [],
  templateUrl: './companies.component.html'
})

export class CompaniesComponent implements OnInit {
  selectedCompany: Company = null;
  showInfoModal: boolean;
  companiesListTitles: DataTableField[];
  customButtons: DataTableCustomButton[];
  selectedApplications: ApplicationCompany[];
  dialogApplication = false;
  newDataAvailable = false;
  modalTitle = '';
  labels = {}
  numberFilter = KontableComponent.NumberFilter;
  showAssociateDialog = false;
  company: Company;

  ngOnInit(): void {

    this.translate.get([
      'companyList.add_title',
      'companyList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['companyList.add_title'];
      this.labels['edit_title'] = res['companyList.edit_title'];
    });

    console.log('companies view onInit...');
    this.srvCompany.getAll().subscribe();
  }

  constructor(
    public srvCompany: CompaniesService,
    private srvDataTable: DataTableService,
    private translate: TranslateService,
    private associationsService: AssociationsService
  ) {
      this.translate.get(['common.name', 'common.host_code', 'common.applications']).subscribe((res) => {
        this.companiesListTitles = [
        { id: 'id', label: '#'},
        { id: 'name', label: res['common.name']},
        { id: 'host_code', label: res['common.host_code']}
      ];

      this.customButtons = [
        {label: res['common.applications'], callbackname: 'applications', icon: 'fa fa-laptop', isAlwaysEnabled: false}
      ];

      });
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.srvCompany.companyEditing = data == null ? new Company() : data;
    this.selectedCompany = this.srvCompany.companyEditing;
    this.showInfoModal = true;
  }

  delete(record): void {
    this.srvCompany.delete(record).subscribe( () => {
      this.newDataAvailable = true;
    });
  }

  companyAdded($event): void {
    this.srvCompany.post($event).subscribe(() => {
      this.srvDataTable.get('dt_company').showDetail = false;
      this.srvCompany.companyEditing = null;
      this.closeDialog ();
      this.newDataAvailable = true;
    });
  }

  companyUpdated($event): void {
    this.srvCompany.put($event).subscribe(() => {
      this.srvDataTable.get ('dt_company').showDetail = false;
      this.srvCompany.companyEditing = null;
      this.closeDialog ();
      this.newDataAvailable = true;
      }
    )
  }

  onCustomButton (row) {
    this.selectedCompany = row;
    this.srvCompany.getApplications(this.selectedCompany).subscribe().add(() => {
      this.selectedApplications = this.srvCompany.applications;
      this.dialogApplication = true;
    });
  }

  closeDialog () {
    this.modalTitle = '';
    this.showInfoModal = false;
  }

  back () {
    this.dialogApplication = false;
  }

  openAssociate(row: Company) {
    this.associationsService.rowId = row.id;
    this.company = row;
    this.showAssociateDialog = true;
  }
}




// WEBPACK FOOTER //
// ./src/app/views/administration/company/companies.component.ts